import React, { useEffect } from "react";
import { useAuthState } from "../../context/AuthContext";
import energo from '../../black-logo.png';
import { InView, useInView } from "react-intersection-observer";
import { Button } from "react-bootstrap";
import defaultAvatar from '../../user.png';
import { FaFileImage, FaFilePdf, FaFileUpload } from "react-icons/fa";

/**
 * 
 * @param {message} props object Message
 * @param {attachments} props array of Attachment object
 * @param {setDate} props setter for string date
 * @param {setIsEnergo} props setter for bool isEnergo which applies color schemes
 * 
 * @returns GUI
 */
const SupportMessage = (props) => {

    const { user } = useAuthState(); // logged User
    const { ref, inView } = useInView({ // observer for Message in view
        rootMargin:"0% 0% -50% 0%",
        threshold: 0 // when 50% in view (100% = 1)
    });

    const imageExtensions = ['jpeg', 'jpg', 'png', 'gif'];
    const documentExtensions = ['pdf', 'doc', 'xls', 'xlsx'];



    // * effect for applying css animation to date element
    useEffect(() => {
        var dateBox = document.getElementById('dateBox');
        if (inView) {
            props.setDate(props.message.date)
            props.setIsEnergo(user.id === props.message.author_id[0] ? false : true);
            dateBox.classList += 'pulse-animate';
        } else {
            dateBox.classList = '';
        }
    }, [inView])

    // * function to download attachment in message
    const downloadAttachment = (attachment) => {
        const linkSource = `data:application/*;base64,${attachment.datas}`;
        const fileName = attachment.name;
        const downloadLink = document.createElement('a');

        downloadLink.href = linkSource;
        downloadLink.download = fileName;
        downloadLink.click();
    }

    // GUI
    return (
        props.message !== undefined ?
            <InView
                className={user.id !== props.message.author_id[0] ? "message-container energo" : "message-container"}
            >
                <div className={user.id !== props.message.author_id[0]? "message-user energo": "message-user"}>
                    <b>{props.message.author_id[1]}</b> am {new Date(props.message.date).toLocaleString('DE-de', {day: '2-digit', month: '2-digit', year: 'numeric', hour: '2-digit', hour12: false, minute: '2-digit'})}
                </div>
                <div className="message-avatar">
                    <img width={100} className="img-fluid" src={user.id === props.message.author_id[0] ? user.image_1920 !== "False"? "data:image/*;base64, "+ user.image_1920: defaultAvatar : energo} alt="avatar" />
                </div>
                {/* <div className={inView ? 'message-content energo animate-slide-left shadow-lg' : 'message-content energo shadow-lg'}> */}
                <div className={`message-content ${user.id !== props.message.author_id[0] ? 'energo':null} ${inView ? 'pulse-animate': null}`}>
                    <div ref={ref} dangerouslySetInnerHTML={{ __html: props.message.body }}></div>
                    <div className="message-attachments mt-5">
                        {props.message.attachment_ids.length > 0 && props.attachments.length > 0 ?
                            <div>
                                <p className="text-muted"><small>Anhänge:</small></p>
                                {props.attachments.map(a => (
                                    props.message.attachment_ids.includes(a.id) ? (
                                        <p>
                                            <a 
                                                href={`download/${a.name}`} 
                                                key={a.id} 
                                                className={user.id !== props.message.author_id[0] ? "link-energo": "link-violet"}
                                                onClick={(e) => {e.preventDefault(); downloadAttachment(a)}} 
                                            >
                                                {
                                                    imageExtensions.includes(a.name.slice(-3))?
                                                        <FaFileImage size={17} /> :
                                                    documentExtensions.includes(a.name.slice(-3))?
                                                       <FaFilePdf size={17}/> :
                                                    <FaFileUpload /> 
                                                }
                                                &nbsp; {a.name}
                                            </a>
                                        </p>
                                    ) : null
                                ))}
                            </div>
                            : null}
                    </div>
                </div>
            </InView>
            :
            null
    )
}

export default SupportMessage;